// extracted by mini-css-extract-plugin
export var bottom = "mainFooter-module--bottom--05a99";
export var copy = "mainFooter-module--copy--d4e2c";
export var dark = "mainFooter-module--dark--1b76e";
export var item = "mainFooter-module--item--c2517";
export var light = "mainFooter-module--light--22969";
export var logo = "mainFooter-module--logo--7442c";
export var modalVideo = "mainFooter-module--modal-video--8997e";
export var modalVideoBody = "mainFooter-module--modal-video-body--ca1ca";
export var modalVideoCloseBtn = "mainFooter-module--modal-video-close-btn--8b6b2";
export var modalVideoEffectExit = "mainFooter-module--modal-video-effect-exit--a76db";
export var modalVideoInner = "mainFooter-module--modal-video-inner--83fe4";
export var modalVideoMovieWrap = "mainFooter-module--modal-video-movie-wrap--ca5cf";
export var nav = "mainFooter-module--nav--d88c0";
export var top = "mainFooter-module--top--a651a";
export var wrapper = "mainFooter-module--wrapper--36361";